import { render, staticRenderFns } from "./AccordionAddButton.vue?vue&type=template&id=4f710ff9&scoped=true"
import script from "./AccordionAddButton.vue?vue&type=script&lang=js"
export * from "./AccordionAddButton.vue?vue&type=script&lang=js"
import style0 from "./AccordionAddButton.vue?vue&type=style&index=0&id=4f710ff9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f710ff9",
  null
  
)

export default component.exports